import { render } from "./AddTextbookModal.vue?vue&type=template&id=243651ae&scoped=true"
import script from "./AddTextbookModal.vue?vue&type=script&lang=js"
export * from "./AddTextbookModal.vue?vue&type=script&lang=js"

import "./AddTextbookModal.vue?vue&type=style&index=0&id=243651ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243651ae"]])

export default __exports__